import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";

// scroll bar
import "simplebar/src/simplebar.css";

// third-party
import { Provider as ReduxProvider } from "react-redux";

// apex-chart
import "assets/third-party/apex-chart.css";

// project import
import App from "./App";
import { store, persistor } from "store";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";

const API_URL = process.env.REACT_APP_API_URL;

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //
// axios.defaults.withCredentials = true;

// intercepting requests
axios.interceptors.request.use(
  function (config) {
    //console.log("axios.interceptors.request");
    // console.log(`axios.interceptors.request config - ${JSON.stringify(config, null, 2)}`);
    // console.log(`axios.interceptors.request config URL - ${config.url}`);
    // console.log(`axios.interceptors.request API_URL - ${API_URL}`);
    let url = config?.url;
    // console.log(`axios.interceptors.request url.includes(API_URL) - ${url.includes(API_URL)}`);
    if (url && url.includes(API_URL)) {
      // For all calls to Vehicle API
      if (localStorage.getItem("token") !== "null") {
        if (localStorage.rememberMe === "true") {
          config.headers = {
            Authorization: localStorage.token,
            "X-Api-Key": localStorage.apiKey,
            //commentout
            "Refresh": localStorage.refresh
          }
        } else if (localStorage.rememberMe === "false") {
          config.headers = {
            Authorization: localStorage.token,
            "X-Api-Key": localStorage.apiKey
          };
        }
        // console.log(`axios.interceptors.request config - ${JSON.stringify(config)}`);
      } else if (localStorage.getItem("GoogleToken") !== "null") {
        config.headers = {
          Authorization: localStorage.GoogleToken,
          "X-Api-Key": localStorage.apiKey
        };
      }
    }
    return config;
  },
  function (error) {
    console.log("axios.interceptors.request error", error);
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    // console.log(`Hello World!!!!!- ${JSON.stringify(res)}`);
    // window.location.href='/login';
    // dispatch(logoutUser());
    return Promise.resolve(res);
  },
  (error) => {
    // console.log(`Axios Intercepter Error! - ${JSON.stringify(error)}`);
    // console.log(`error.response - \n${JSON.stringify(error.response, null, 2)}`);
    // console.log(`error.toJSON - ${JSON.stringify(error.toJSON())}`);
    // console.log(
    //   `error.response.config - \n${JSON.stringify(error.response.config, null, 2)}`
    // );
    // console.log(
    //   `error.response.config?.url - \n${JSON.stringify(
    //     error.response?.config?.url, null, 2
    //   )}`
    // );
    // console.log(`error.response.status - ${error.response.status}`);
    if (error && error.response?.status === 401) {
      // Check if the request is to the JNR API
      if (error.response?.config?.url && error.response?.config?.url.includes(API_URL)) {
        localStorage.clear();
        sessionStorage.clear();
        // redirect to login page if current page not login page
        // console.log(
        //   `not login page?
        //   !window.location.href.endsWith("/login") - ${!window.location.href.endsWith("/login")}`
        // )
        if (!window.location.href.endsWith("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </ReduxProvider>
  </StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
